import "./Profile.module.css";
import Header from "@/reusable_sections/Header";
import Colloca from "./sections/Colloca";
import Curriculum from "./sections/Curriculum";
import Statistics from "./sections/Statistics";
import Footer from "@/reusable_sections/Footer";
export default function ProfilePage() {
  return <div>
      <Header />
      <Colloca />
      <Curriculum />
      <Statistics />
      <Footer />
    </div>;
}